export class ClientSideValidationError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'ClientSideValidationError';
	}
}

export const isClientSideValidationError = (error: unknown): error is ClientSideValidationError =>
	error instanceof ClientSideValidationError;
